import { render, staticRenderFns } from "./AxUnreadMentionsIndicator.vue?vue&type=template&id=c5321bb0&scoped=true&"
import script from "./AxUnreadMentionsIndicator.vue?vue&type=script&lang=ts&"
export * from "./AxUnreadMentionsIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./AxUnreadMentionsIndicator.vue?vue&type=style&index=0&id=c5321bb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5321bb0",
  null
  
)

export default component.exports